import {remCalc} from '../../_utils'

export default {
    baseStyle: ({basketLength}: {basketLength: number}) => ({
        subscriptionsContainer: {
            display: 'flex',
            flexDir: 'column',
            paddingX: remCalc(24),
            paddingY: remCalc(16),
            borderRadius: remCalc(4),
            backgroundColor: 'background.light',
            mb: remCalc(8),
        },
        errorText: {
            textStyle: 'body-xxsmall',
            color: 'text.danger',
            mt: remCalc(4),
        },
        subscriptionsTextsContainer: {
            alignItems: 'center',
        },
        subscriptionsText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            ml: remCalc(8),
        },
        subscriptionsLink: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            textDecoration: 'underline',
            cursor: 'pointer',
            ml: remCalc(4),
        },
        orderSummaryBox: {
            w: {base: '100%'},
        },
        summaryContainer: {
            display: 'flex',
            paddingY: remCalc(16),
            paddingX: remCalc(24),
            gap: remCalc(0),
            flexDir: 'column',
            borderRadius: 'medium.lg',
            bg: 'background.light',
            minWidth: {lg: 'unset', xl: remCalc(451)},
        },
        innerSummaryContainer: {
            pb: {base: remCalc(12), lg: remCalc(16)},
        },
        mobileOrderReviewContainer: {
            align: 'flex-start',
            justify: 'space-between',
            paddingY: remCalc(24),
            paddingX: remCalc(24),
            cursor: 'pointer',
        },
        promo: {
            promoContainer: {
                width: 'full',
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                borderRadius: ['medium.lg', 'medium.md', 'medium.sm', 'medium.base'],
                bg: 'background.light',
                marginBottom: remCalc(8),
            },
        },
        zipCode: {
            zipCodeContainer: {
                width: 'full',
                display: 'flex',
                paddingY: {base: remCalc(10), lg: remCalc(12)},
                flexDir: 'row',
                borderRadius: ['medium.lg', 'medium.md', 'medium.sm', 'medium.base'],
                justifyContent: 'space-between',
                alignItems: 'center',
            },
            zipCodeInput: {
                bg: 'background.default',
            },
            zipCodeText: {
                textStyle: 'body-small',
                color: 'text.default',
                fontWeight: 'normal',
            },
            zipCodeEdit: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            zipCodeEditIcon: {
                boxSize: 'iconsSize.small',
            },
            zipCodeEditContainer: {
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: remCalc(4),
            },
            zipCodeInfoContainer: {
                gap: remCalc(8),
                alignItems: 'center',
            },
            zipInputContainer: {
                w: '100%',
                paddingY: {base: remCalc(4), lg: remCalc(8)},
            },
        },
        summaryHeader: {
            itemContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
                paddingY: remCalc(8),
            },
            headerText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
        },
        subtotalSection: {
            subtotalPriceContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                paddingY: remCalc(12),
            },
            subtotalContainer: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                paddingTop: {base: remCalc(0), lg: remCalc(8)},
                paddingBottom: {base: remCalc(12), lg: remCalc(8)},
            },
            shippingContainer: {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                paddingY: {base: remCalc(12), lg: remCalc(8)},
            },
            subtotalStackContainer: {
                flex: 1,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            },
            subtotalText: {
                color: 'text.default',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            freeShippingText: {
                color: 'text.success',
                textStyle: 'body-small',
            },
            infoIconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // border: remCalc(1),
                // borderStyle: 'solid',
                // borderColor: 'border.dark',
                borderRadius: '50%',
            },
            infoIcon: {
                display: 'flex',
                w: 'iconsSize.small',
                h: 'iconsSize.small',
                color: 'text.default',
                fill: 'none',
            },
            shippingEstimationn: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            savedAmountContainer: {
                textStyle: 'body-small',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: remCalc(12),
            },
        },
        checkoutSection: {
            checkoutContainer: {
                display: 'flex',
                paddingTop: 'xsmall.lg',
                flexDir: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
                gap: remCalc(8),
                paddingBottom: 'xsmall.base',
            },
            totalText: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'bold',
            },
            klarnaText: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
            },
            goToCheckoutButtonContainer: {
                position: {base: 'fixed', lg: 'unset'},
                left: '0',
                bottom: '0',
                width: '100%',
                background: {base: 'background.light', lg: 'unset'},
                px: {base: 'small.base', lg: 'unset'},
                paddingTop: 'small.base',
                paddingBottom: 'xsmall.base',
                zIndex: '3',
            },
            goToCheckoutButtonContainerSticky: {
                paddingTop: 'xsmall.base',
                paddingBottom: 'xsmall.lg',
            },
            //_hover style removed, since the standard primary button hover style is sufficient
            goToCheckout: {
                width: '100%',
                /* _hover: {
                    textDecoration: 'none',
                    bg: 'button.text.text-hover',
                }, */
            },
            checkoutTotalContainer: {
                display: {base: 'flex', lg: 'none'},
                pb: 'xsmall.base',
            },
            vatInCheckoutButton: {
                textStyle: 'body-xxsmall',
                pl: 'xsmall.base',
                alignSelf: 'center',
            },
        },
        promoCode: {
            inputContainer: {
                display: 'flex',
                flexDir: 'column',
                minWidth: remCalc(140),
                paddingY: 0,
                gap: 'small.base',
                alignSelf: 'stretch',
                w: '100%',
            },
            inputContainerHeader: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
                mb: 'xsmall.base',
            },
            applyButton: {
                variant: 'text-button',
                marginLeft: 'xsmall.base',
            },
            inputProps: {
                display: 'flex',
                minHeight: remCalc(40),
                paddingX: 'xsmall.base',
                paddingY: 'small.base',
                // justifyItems: 'center',
                // alignSelf: 'stretch',
                borderRadius: ['medium.lg', 'medium.md', 'medium.sm', 'medium.base'],
                bg: 'background.default',
            },
            referralLink: {
                color: 'button.text.text-default',
                textStyle: 'body-small',
                fontWeight: 'normal',
                textOverflow: 'ellipsis',
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                'text-decoration-skip-ink': 'none',
                textDecorationThickness: 'auto',
                textUnderlineOffset: 'auto',
                flex: '1 1 0',
            },
            textContainer: {
                alignItems: 'center',
                justifyContent: 'space-between',
            },
            couponSuccessContainer: {
                alignItems: 'center',
                justifyContent: 'center',
                gap: {
                    base: 'xsmall.base',
                    sm: 'xsmall.sm',
                },
            },
            textCoupon: {
                textStyle: 'body-small',
                color: 'text.success',
                fontWeight: 'normal',
            },
            couponSuccessIcon: {
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
                color: 'text.success',
            },
        },
        cartItems: {
            container: {
                // py: remCalc(12),
                // pt: remCalc(4),
                pt: remCalc(8),
                maxHeight: remCalc(300),
                overflowY: basketLength >= 2 ? 'scroll' : 'none',
                '::-webkit-scrollbar': {
                    width: remCalc(6),
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'button.border.inverse-primary-focused',
                    borderRadius: remCalc(6.5),
                },
            },
            itemsText: {
                textStyle: 'body-small',
            },
            itemsContainer: {
                // paddingBottom: remCalc(24),
                pt: remCalc(16),
                w: '100%',
            },
            innerItemContainer: {
                // minWidth: remCalc(109),
                width: 'full',
                alignItems: 'flex-start',
                gap: remCalc(16),
                // mb: remCalc(16),
            },
            stack: {
                // width: 'full',
                gap: remCalc(16),
            },
            itemVariant: {
                textStyle: 'body-medium',
                fontWeight: 'bold',
            },
            stackContent: {
                flexDirection: 'column',
                gap: remCalc(4),
            },
            itemVariantAttributes: {
                textStyle: 'body-xsmall',
            },
        },
    }),
    variants: {
        checkout: {
            orderSummaryBox: {
                paddingBottom: remCalc(24),
                paddingX: remCalc(24),
            },
            summaryContainer: {
                paddingY: 'unset',
                paddingX: 'unset',
            },
            summaryHeader: {
                itemContainer: {
                    display: 'none',
                },
            },
            cartItems: {
                container: {
                    pb: 'unset',
                },
                itemsContainer: {
                    pt: 'unset',
                },
            },
        },
    },
}
